import React from 'react';
import { Moon } from 'lucide-react';
// Lightweight wrapper. No framer-motion, no IntersectionObserver.
// Uses CSS opacity transitions only if the element is below the fold.
export const FadeIn = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => {
  return <div className={className} data-id="element-130">{children}</div>;
};
export const Divider = () => <div className="flex items-center justify-center py-16 opacity-40" data-id="element-131">
    <div className="h-px w-16 bg-gradient-to-r from-transparent via-parchment-muted to-transparent" data-id="element-132" />
    <div className="mx-4 text-amber animate-pulse-slow" data-id="element-133">
      <Moon size={14} strokeWidth={1.5} data-id="element-134" />
    </div>
    <div className="h-px w-16 bg-gradient-to-l from-transparent via-parchment-muted to-transparent" data-id="element-135" />
  </div>;
export const Button = ({
  children,
  onClick,
  href,
  className = ''
}: {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
}) => {
  const classes = `bg-amber text-midnight font-medium px-8 py-4 rounded-md transition-all duration-200 hover:bg-amber-hover hover:shadow-[0_0_20px_rgba(212,154,92,0.2)] active:scale-[0.98] flex items-center justify-center gap-2 ${className}`;
  if (href) {
    return <a href={href} onClick={onClick} className={classes} data-id="element-136">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={classes} data-id="element-137">
      {children}
    </button>;
};